import * as React from 'react';
import * as ReactDOM from 'react-dom';

import {
	Root,
	View,
	Header,
	Content,
} from './styled';


type PortalProps = {
	zIndex?: number;
}

class PortalBase extends React.Component<PortalProps> {
	domNode: HTMLElement = null;

	componentDidMount() {
		this.domNode = document.createElement('div');
		document.body.appendChild(this.domNode);
    this.forceUpdate();
	}
	
	componentWillUnmount() {
		this.domNode && this.domNode.parentElement && this.domNode.parentElement.removeChild(this.domNode);
	}

	render() {
		if (!this.domNode) return null;

		return ReactDOM.createPortal(
			<Root {...this.props} />,
			this.domNode
		);
	}
}

const Portal = {
	Base: PortalBase,
	View,
	Header,
	Content,
};

export default Portal;
